import {Emisor} from './emisor';

export class GreCarrier {
    id: any;
    type: string;
    ruc: string;
    businessName: string;
    mtcRecord: string;
    documentType: any;
    documentNumber: any;
    name: any;
    lastName: any;
    licenseNumber: any;
    constructor() {
        this.type = 'PUBLIC';
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/recursos/modelo/gre-carrier.ts